import React from 'react';
import './Home.css';

const facilities = [
  {
    title: 'Library',
    image: '/external/images/library.jpeg',
    text: 'Dive into a calm reading environment built for discovery, imagination, and focused study.'
  },
  {
    title: 'Playground',
    image: '/external/images/playground.jpeg',
    text: 'A vibrant outdoor space that encourages movement, teamwork, and a healthy routine.'
  },
  {
    title: 'Science Labs',
    image: '/external/images/sciencelabs.jpeg',
    text: 'Hands-on labs where curiosity turns into experimentation and deeper understanding.'
  }
];

const Facility = () => {
  return (
    <section className="facilities section-shell">
      <div className="section-heading">
        <span className="section-kicker">Facilities</span>
        <h2>Learning spaces designed to feel active, polished, and practical.</h2>
        <p>
          From reading to sports to experimentation, our campus facilities support daily growth
          in more than one way.
        </p>
      </div>

      <div className="row">
        {facilities.map((item) => (
          <article className="facilities-col" key={item.title}>
            <img src={item.image} alt={item.title} />
            <div className="facilities-col__content">
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Facility;
